import {
    GET_HELP,
    GET_HELP_SUCCESS,
    GET_HELP_FAILURE,
    UPDATE_HELP_STATUS,
    UPDATE_HELP_STATUS_SUCCESS,
    UPDATE_HELP_STATUS_FAILURE,
    ADD_HELP,
    ADD_HELP_SUCCESS,
    ADD_HELP_FAILURE,
    EDIT_HELP,
    EDIT_HELP_SUCCESS,
    EDIT_HELP_FAILURE,
    DELETE_HELP,
    DELETE_HELP_SUCCESS,
    DELETE_HELP_FAILURE,
    GET_HELP_DETAILS,
    GET_HELP_DETAILS_SUCCESS,
    GET_HELP_DETAILS_FAILURE,
    QUESTION_DROPDOWN_LIST,
    QUESTION_DROPDOWN_LIST_SUCCESS,
    QUESTION_DROPDOWN_LIST_FAILURE,
    UPDATE_HELP_ORDER_STATUS,
    UPDATE_HELP_ORDER_STATUS_SUCCESS,
    UPDATE_HELP_ORDER_STATUS_FAILURE
} from "../Constants"

const init = {
    data: {},
    status_data: {},
    edit_data: {},
    add_data: {},
    delete_data:{},
    details_data:{},
    question_data:{},
    order_data:{}
};

const HelpReducer = (state = init, action) => {
    switch (action.type) {
        case GET_HELP:
            return { ...state, loading: true };
        case GET_HELP_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_HELP_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case UPDATE_HELP_STATUS:
            return { ...state, loading: true };
        case UPDATE_HELP_STATUS_SUCCESS:
            return { ...state, loading: false, status_data: action.payload };
        case UPDATE_HELP_STATUS_FAILURE:
            return { ...state, loading: false, status_data: action.payload };
        case ADD_HELP:
            return { ...state, loading: true };
        case ADD_HELP_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_HELP_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case EDIT_HELP:
            return { ...state, loading: true };
        case EDIT_HELP_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_HELP_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case DELETE_HELP:
            return { ...state, loading: true };
        case DELETE_HELP_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_HELP_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        case GET_HELP_DETAILS:
            return { ...state, loading: true };
        case GET_HELP_DETAILS_SUCCESS:
            return { ...state, loading: false, details_data: action.payload };
        case GET_HELP_DETAILS_FAILURE:
            return { ...state, loading: false, details_data: action.payload };
        case QUESTION_DROPDOWN_LIST:
            return { ...state, loading: true };
        case QUESTION_DROPDOWN_LIST_SUCCESS:
            return { ...state, loading: false, question_data: action.payload };
        case QUESTION_DROPDOWN_LIST_FAILURE:
            return { ...state, loading: false, question_data: action.payload };
        case UPDATE_HELP_ORDER_STATUS:
            return { ...state, loading: true };
        case UPDATE_HELP_ORDER_STATUS_SUCCESS:
            return { ...state, loading: false, order_data: action.payload };
        case UPDATE_HELP_ORDER_STATUS_FAILURE:
            return { ...state, loading: false, order_data: action.payload };
        default:    
            return state;
    }
};

export default HelpReducer;